var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.999.833C4.944.833.832 4.946.832 10c0 5.055 4.112 9.167 9.167 9.167s9.166-4.113 9.166-9.167S15.053.833 10 .833m.916 12.953a.917.917 0 0 1-1.833 0V9.203a.917.917 0 0 1 1.833 0zm0-7.453a.917.917 0 1 1-1.833 0 .917.917 0 0 1 1.833 0"
})));
export default SvgInfoCircleFill;